import * as React from 'react';
import { LazyLoad } from '@cian/lazyload-component';

import { declineNumeric, formatPrice } from '../../../shared/utils/format_helper';
import { waitForImage } from '../../../shared/utils/lazy_load_helper';
import { Link } from '../link/link';

const s = require('./popular_item.css');

interface IProps {
  metro?: {
    timeType: string;
    name: string;
    lineColor: string;
    time: number;
  };
  title: string;
  url: string;
  priceAmount: number;
  price: {
    amount: number;
    priceType?: string;
  };
  address?: string;
  thumbnailUrl: string;
  onClick(): void;
}

class PopularItem extends React.Component<IProps> {
  public renderAddress() {
    if (this.props.metro) {
      return (
        <div className={s['c-popular-metro']}>
          <span className={s['c-popular-metro-name']}>
            <span
              className={s['c-line-marker']}
              style={{
                backgroundColor: `#${this.props.metro.lineColor}`,
              }}
            />
            {this.props.metro.name}
          </span>
          {this.props.metro.time !== null && (
            <span className={s['c-popular-metro-time']}>
              {this.props.metro.time}
              &nbsp;
              {declineNumeric(this.props.metro.time, ['минута', 'минуты', 'минут'])}
              &nbsp; пешком
            </span>
          )}
        </div>
      );
    } else {
      return <div className={s['c-popular-address']}>{this.props.address}</div>;
    }
  }

  public render() {
    return (
      <Link href={this.props.url} className={`${s['c-popular-block']} cg-col-8`} onClick={() => this.props.onClick()}>
        <LazyLoad
          onLoad={() => waitForImage(this.props.thumbnailUrl)}
          renderEmpty={() => <div className={s['c-popular-photo-wrap']} />}
          renderLoading={() => <div className={s['c-popular-photo-wrap']} />}
          renderLoaded={(imageUrl: string) => (
            <div
              className={s['c-popular-photo-wrap']}
              style={{
                backgroundImage: `url(${this.props.thumbnailUrl})`,
              }}
            />
          )}
          renderError={() => <div className={s['c-popular-photo-wrap']}></div>}
        />
        <div className={s['c-popular-info']}>
          <span className={s['c-popular-price']}>
            {formatPrice(this.props.price.amount, 4)}
            <span> ₽</span>
          </span>
          <span className={s['c-popular-tec-info']} dangerouslySetInnerHTML={{ __html: this.props.title }} />
          {this.renderAddress()}
        </div>
      </Link>
    );
  }
}

export { PopularItem };
